import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import React from "react";
import Grid from "@material-ui/core/Grid";
import CardButtonIcon from "./CardButtonIcon";
import cardButtonStyles from "../styles/CardButton.styles";
import TeamLogo from "../../team/components/TeamLogo";

const CardButton = ({
	id,
	text,
	icon,
	onClick,
	size = "medium",
	correctionFactor = 0,
	textAlign = "left",
	active,
	team
}) => {
	const classes = cardButtonStyles({
		active,
		size,
		correctionFactor,
		textAlign: team || !icon ? "center" : "flex-start"
	});
	return (
		<div className={classes.root}>
			<div className={classes.aspectRatioBox}>
				<div className={classes.aspectRatioBoxInside}>
					<Card className={classes.card}>
						<CardActionArea
							onClick={onClick}
							className={classes.cardAction}
							id={`action-${id}`}
							aria-label={text}
							aria-pressed={active}
						>
							<CardContent className={classes.cardContent}>
								<Grid container className={classes.grid}>
									<Grid
										item
										md={icon || team ? 6 : 12}
										className={classes.textContainer}
									>
										<Typography
											variant="h6"
											align={textAlign}
											className={classes.actionText}
										>
											{text}
										</Typography>
									</Grid>
									{icon && (
										<Grid item md={6}>
											<Grid container className={classes.iconContainer}>
												<CardButtonIcon iconName={icon} />
											</Grid>
										</Grid>
									)}
									{team && (
										<Grid item md={6}>
											<Grid container className={classes.iconContainer}>
												<TeamLogo team={team} hideName size="small" />
											</Grid>
										</Grid>
									)}
								</Grid>
							</CardContent>
						</CardActionArea>
					</Card>
				</div>
			</div>
		</div>
	);
};

export default CardButton;
